import script from "./LayoutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutPage.vue?vue&type=script&setup=true&lang=js"

import "./LayoutPage.vue?vue&type=style&index=0&id=1a599ae8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a599ae8"]])

export default __exports__